export class NewRole {
    id: any = null;
    role: String = '';
}